import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const DataflowDiagrams: React.FC = () => {
  const sections = [
    {
      title: 'Data Flow Mapping and Analysis',
      content: 'Our data flow diagram services provide comprehensive visualization of how data moves through your organization, helping identify security risks, compliance requirements, and optimization opportunities. We create detailed maps that support risk assessments, privacy impact assessments, and regulatory compliance.',
      benefits: [
        'Comprehensive data flow mapping',
        'Security control identification',
        'Privacy impact assessment support',
        'Compliance documentation',
        'Risk identification and mitigation'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Dataflow Diagrams"
      subtitle="Comprehensive data flow mapping and analysis to visualize data movement and identify security risks throughout your organization."
      sections={sections}
    />
  );
};

export default DataflowDiagrams;

